/* A trust badge opens the existing delivery disclosure. */
(() => {
  if (window.craftGuideDetailsBound) return;
  window.craftGuideDetailsBound = true;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cp-open-details]');
    if (!trigger) return;
    const details = document.getElementById(trigger.dataset.cpOpenDetails);
    if (!details || details.tagName !== 'DETAILS') return;
    details.open = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.dataset.cbMotion === 'false';
    details.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    details.querySelector('summary')?.focus({ preventScroll: true });
  });
})();
